import Cookies from 'js-cookie';
import get from 'lodash/get';
import first from 'lodash/first';
import { PROP_ID } from 'redux/models/offices/model';

const addParamToSearchString = (search, paramName, value) => {
  const paramStr = `${ paramName }=${ value }`;
  if (!search) {
    return paramStr;
  }
  return (
    search
      .substring(1)
      .split('&')
      .filter((query) => first(query.split('=')) !== paramName)
      .filter((query) => first(query.split('=')) !== 'd') // http://bt.abcp.ru/view.php?id=345994#1945845
      .concat([paramStr])
      .join('&')
  );
};

export const goToOfficePage = (office) => {
  const { search, origin, pathname, hash } = location;
  const queryString = addParamToSearchString(search, 'FranchiseeId', office[PROP_ID]);
  location.href = `${ origin }${ pathname }?${ queryString }${ hash }`;
};

export const setCookieResellerId = (office) => {
  const resellerId = parseInt(get(office, PROP_ID), 10);
  if (resellerId) {
    const options = { expires: 365, path: '/', domain: location.hostname };
    Cookies.set('resellerId', resellerId, options);
  }
};
